import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-cpp',
  templateUrl: './landing-cpp.component.html',
  styleUrls: ['./landing-cpp.component.scss']
})
export class LandingCppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
